export default "__VITE_ASSET__BDKc8ZVL__"